import { createContext, useReducer } from "react";

const initialData = [];
export const SavedConfigurationsContext = createContext(null);
export const SavedConfigurationsDispatch = createContext(null);
export const SavedConfigurationsProvider = ({ children }) => {
    const [savedConfigurations, dispatch] = useReducer(
        SavedConfigurationsReducer,
        initialData
    );
    return (
        <SavedConfigurationsContext.Provider value={savedConfigurations}>
            <SavedConfigurationsDispatch.Provider value={dispatch}>
                {children}
            </SavedConfigurationsDispatch.Provider>
        </SavedConfigurationsContext.Provider>
    );
};

function SavedConfigurationsReducer(savedConfigurations, action) {
    switch (action.type) {
        case "set":
            return action.payload;
        default:
            throw new Error('Unknown action: ' + action.type);
    }
}